const TrashIcon = (): JSX.Element => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 18.2L11 8" stroke="#FF6060" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7.40003 18.2L7.40002 8"
      stroke="#FF6060"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14.6 18.2L14.6 8" stroke="#FF6060" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M20.6 3.79981L1.40002 3.7998"
      stroke="#FF6060"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1863 3.7998H4.81387C3.20007 3.7998 3.20007 3.7998 3.20007 5.5998V19.3998C3.20007 20.3939 3.92259 21.1998 4.81387 21.1998H17.1863C18.0776 21.1998 18.8001 20.3939 18.8001 19.3998V5.5998C18.8001 3.7998 18.8001 3.7998 17.1863 3.7998Z"
      stroke="#FF6060"
    />
    <path
      d="M7.40002 3.1999C7.40002 1.9999 8.25093 1.3999 9.56002 1.3999C11.1964 1.3999 11.7855 1.3999 12.44 1.3999C12.9855 1.3999 14.6 1.3999 14.6 3.1999"
      stroke="#FF6060"
    />
  </svg>
);

export default TrashIcon;
